import { useMutation } from "react-query";
import http from "infra/http";

function useDuplicarRelatorioPrestacaoContasTenants() {
  return useMutation(
    ({ id, tenantsIds }: { id: string; tenantsIds: string[] }) => {
      return http.post<{ id: string; nome: string; tenantId: string }[]>(
        `/v1/relatorios/financeiro/prestacao-contas/${id}/duplicar-tenants`,
        { tenantsIds }
      );
    },
    { retry: false }
  );
}

export default useDuplicarRelatorioPrestacaoContasTenants;
